import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useOutletContext } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";
import { currency_converter_inr } from "../../utils/currencyUtils";
import useSmartBack from "../../hooks/useSmartBack";

function Revenuerisk() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();
  const [croptions, setcroptions] = useState([]);
  const [pcroptions, setpcroptions] = useState([]);
  const [filteredTotal, setFilteredTotal] = useState(0);
  const [prfilterTotal, setprfilterTotal] = useState(0);
  const handleBack = useSmartBack("/client/list");

  useEffect(() => {
    const getCurrentYearRevenue = async () => {
      setGlobalLoading(true);
      try {
        const response = await axios.get(
          `${API_BASE_URL}/clients/get_current_year_revenue_risk_report/`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setcroptions(response.data.current_year_revenue_risk_report);
        setpcroptions(response.data.invoice_raised_last_year);
        console.log(response.data);
      } catch (error) {
        setGlobalLoading(false);
        console.log(error);
        setGlobalLoading(false);
      } finally {
        setGlobalLoading(false);
      }
    };
    getCurrentYearRevenue();
  }, []);

  const columns = [
    {
      accessorKey: "raised_date",
      header: "Raised Date",
      size: 70,
    },
    {
      accessorKey: "Bd",
      header: "BD By",
      size: 70,
    },
    {
      accessorKey: "BuHead",
      header: "Role Manager",
      size: 70,
    },
    {
      accessorKey: "Em",
      header: "Assign To",
      size: 70,
    },
    {
      accessorKey: "company_name",
      header: "Client",
      size: 100,
    },
    {
      accessorKey: "role_name",
      header: "Role",
      size: 100,
    },
    {
      accessorKey: "candidate_name",
      header: "Candidate Name",
      size: 100,
    },
    {
      accessorKey: "entity_name",
      header: "Entity",
      size: 50,
    },
    {
      accessorKey: "amount",
      header: `Invoice Amt`,
      size: 70,
      Cell: (info) => currency_converter_inr(info.cell.getValue() ?? 0),
    },
    {
      accessorKey: "status",
      header: "Status",
      size: 70,
    },
    {
      accessorKey: "stage",
      header: "Stage",
      size: 70,
    },
    {
      accessorKey: "interval_days",
      header: "Days",
      size: 70,
    },
  ];

  const columns1 = [
    {
      accessorKey: "raised_date",
      header: "Raised Date",
      size: 70,
    },
    {
      accessorKey: "Bd",
      header: "BD By",
      size: 70,
    },
    {
      accessorKey: "BuHead",
      header: "Role Manager",
      size: 70,
    },
    {
      accessorKey: "Em",
      header: "Assign To",
      size: 70,
    },
    {
      accessorKey: "company_name",
      header: "Client",
      size: 100,
    },
    {
      accessorKey: "role_name",
      header: "Role",
      size: 100,
    },
    {
      accessorKey: "candidate_name",
      header: "Candidate Name",
      size: 100,
    },
    {
      accessorKey: "entity_name",
      header: "Entity",
      size: 50,
    },
    {
      accessorKey: "amount",
      header: `Invoice Amt`,
      size: 70,
      Cell: (info) => currency_converter_inr(info.cell.getValue() ?? 0),
    },
    {
      accessorKey: "status",
      header: "Status",
      size: 70,
    },
    {
      accessorKey: "stage",
      header: "Stage",
      size: 70,
    },
    {
      accessorKey: "interval_days",
      header: "Days",
      size: 70,
    },
  ];

  return (
    <>
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Revenue At Risk</h2>
          </div>
          <div className="my-auto">
            <button
                className="btn btn-outline-secondary btn-sm d-inline-flex align-items-center"

              onClick={handleBack}
            >
              <i className="ti ti-arrow-left me-2"></i>
              Back 
            </button>
          </div>
        </div>

        <div className="card">
          <div className="card-header d-flex align-items-center flex-wrap row-gap-3">
            <h5>
              Currenct Year Report:{" "}
              <span style={{ fontWeight: "bold", color: "#007bff" }}>
                {currency_converter_inr(filteredTotal)}
              </span>
            </h5>
          </div>
          <div className="card-body">
            <div className="custom-datatable-filter table-responsive">
              <MaterialReactTable
                columns={columns}
                data={croptions}
                initialState={{
                  pagination: { pageSize: 100 },
                }}
                muiTableBodyCellProps={{
                  sx: {
                    padding: "2px 4px", // compact cell padding
                  },
                }}
                muiTableHeadCellProps={{
                  sx: {
                    padding: "2px 4px", // same as body cells
                    height: "30px", // or less
                  },
                }}
                renderTopToolbarCustomActions={({ table }) => {
                  // Calculate total whenever filtered data changes
                  const total = table
                    .getPrePaginationRowModel()
                    .rows.reduce(
                      (sum, row) => sum + (row.original.amount || 0),
                      0
                    );
                  if (total !== filteredTotal) setFilteredTotal(total);
                  return null;
                }}
                muiTableBodyRowProps={({ row }) => {
                  const interval_days = row.original.interval_days;

                  let bgColor = "";
                  let color = "black";
                  if (interval_days > 14 && interval_days <= 30) {
                    bgColor = "yellow";
                  } else if (interval_days > 30 && interval_days <= 60) {
                    bgColor = "orange";
                  } else if (interval_days > 60 && interval_days <= 90) {
                    bgColor = "chocolate";
                    color = "white";
                  } else if (interval_days > 90) {
                    bgColor = "darkred";
                    color = "white";
                  }

                  return {
                    sx: {
                      backgroundColor: bgColor,
                      height: "20px",
                      color: color,
                      "&:hover": {
                        backgroundColor: bgColor, // keep same on hover
                        height: "20px",
                        color: color,
                      },
                      "& td": {
                        // ensure cell text also inherits
                        color: color,
                      },
                    },
                  };
                }}
              />
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-header d-flex align-items-center flex-wrap row-gap-3">
            <h5>
              Previous Year Report:{" "}
              <span style={{ fontWeight: "bold", color: "#007bff" }}>
                {currency_converter_inr(prfilterTotal)}
              </span>
            </h5>
          </div>
          <div className="card-body p-0">
            <div className="custom-datatable-filter table-responsive">
              <MaterialReactTable
                columns={columns1}
                data={pcroptions}
                initialState={{
                  pagination: { pageSize: 100 },
                }}
                muiTableBodyRowProps={({ row }) => {
                  const interval_days = row.original.interval_days;

                  let bgColor = "";
                  let color = "black";
                  if (interval_days > 14 && interval_days <= 30) {
                    bgColor = "yellow";
                  } else if (interval_days > 30 && interval_days <= 60) {
                    bgColor = "orange";
                  } else if (interval_days > 60 && interval_days <= 90) {
                    bgColor = "chocolate";
                    color = "white";
                  } else if (interval_days > 90) {
                    bgColor = "darkred";
                    color = "white";
                  }

                  return {
                    sx: {
                      backgroundColor: bgColor,
                      height: "20px",
                      color: color,
                      "&:hover": {
                        backgroundColor: bgColor, // keep same on hover
                        height: "20px",
                        color: color,
                      },
                      "& td": {
                        // ensure cell text also inherits
                        color: color,
                      },
                    },
                  };
                }}
                muiTableBodyCellProps={{
                  sx: {
                    padding: "2px 4px", // compact cell padding
                  },
                }}
                muiTableHeadCellProps={{
                  sx: {
                    padding: "2px 4px", // same as body cells
                    height: "30px", // or less
                  },
                }}
                renderTopToolbarCustomActions={({ table }) => {
                  // Calculate total whenever filtered data changes
                  const total = table
                    .getPrePaginationRowModel()
                    .rows.reduce(
                      (sum, row) => sum + (row.original.amount || 0),
                      0
                    );
                  if (total !== filteredTotal) setprfilterTotal(total);
                  return null;
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Revenuerisk;
